import axios, { AxiosPromise } from 'axios'

interface CacheRemovableResp {
  status: boolean
  keysDeleted: string[]
}

export const clearCacheMenu = ({
  menuName
}: {
  menuName: string
}): AxiosPromise<CacheRemovableResp> =>
  axios.post('/api/fesc/v1/clear-cache-ssr-menu', {
    menuName
  })
